/* eslint-disable indent */

import {
  IAssessmentRequestsRawData,
  IAssessmentsFilterName,
  TAssessmentRequestDetailsRawResponse,
  TAssessmentRequestsDetailsData,
} from '../types';

/**
 * Formats the response data from the assessment details API as per to be used
 * in the UI.
 */
export function formatAutoAssessmentsRequestsDetailsResponse(
  rawData: TAssessmentRequestDetailsRawResponse
): TAssessmentRequestsDetailsData {
  const { message, isRequestBlocked, data } = rawData || {};

  if (isRequestBlocked) {
    return {
      type: 'BLOCKED',
      message,
      isRequestBlocked,
    };
  }

  const {
    assessmentStatus,
    assetDetail,
    autoAssessmentType = null,
    conditionInfo,
    cosmetic,
    createdDate,
    existingDeal,
    imageBaseURL = null,
    images = [],
    reviewedByInfo,
    sessionId = '',
    storeInfo,
  } = (data || {}) as IAssessmentRequestsRawData;

  const formattedStatus =
    assessmentStatus?.map((item) => {
      const { key, label, label_ar: labelAr } = item || {};
      const localizedLabel = { en: label, ar: labelAr || label };

      return {
        key,
        label: localizedLabel,
        labelStr: label,
      };
    }) || [];

  const formattedAssetDetail = {
    assetId: assetDetail?._id || '',
    label: {
      en: assetDetail?.label || '',
      ar: assetDetail?.label_ar || assetDetail?.label || '',
    },
    labelStr: assetDetail?.label || '',
  };

  const formattedCosmetic =
    cosmetic?.map((cosmeticItem) => {
      const { checkName, conditions } = cosmeticItem || {};

      const formattedConditionsList = conditions.map((condition) => {
        const { label, label_ar: labelAr, value } = condition || {};
        const localizedLabel = { en: label, ar: labelAr || label };

        return { label: localizedLabel, value };
      });

      return {
        checkName,
        conditions: formattedConditionsList,
      };
    }) || [];

  const formattedCondition = conditionInfo ? conditionInfo.condition : null;

  const formattedStoreInfo = storeInfo
    ? {
        headOfficeName: storeInfo.headOfficeName,
        name: storeInfo.name,
      }
    : null;

  const formattedReviewedByInfo = reviewedByInfo
    ? {
        name: reviewedByInfo.name,
      }
    : null;

  let existingDealInfo = null;

  if (existingDeal) {
    const {
      condition,
      createdDate: dateCreated,
      reviewedByInfo: reviewedByInfoInfo,
      storeInfo: exitStoreInfo,
    } = existingDeal;

    existingDealInfo = {
      condition: condition?.condition,
      createdDate: dateCreated,
      reviewedBy: reviewedByInfoInfo?.name,
      storeInfo: exitStoreInfo?.name,
    };
  }

  const isPendingRequest =
    formattedStatus &&
    formattedStatus.length > 0 &&
    formattedStatus[0]?.key === IAssessmentsFilterName.PENDING;

  return {
    type: 'PENDING',
    content: {
      assetDetail: formattedAssetDetail,
      autoAssessmentStatuses: formattedStatus,
      autoAssessmentType,
      condition: formattedCondition,
      cosmetics: formattedCosmetic,
      createdDate,
      existingDeal: existingDealInfo,
      imageBaseURL,
      images,
      isPendingRequest,
      reviewedByInfo: formattedReviewedByInfo,
      sessionId,
      storeInfo: formattedStoreInfo,
    },
  };
}
